// ─────────────────────────────────────────────────────────────
// Jerry custom marker types
// Do not edit core OpenDAW files — all customizations live here
// ─────────────────────────────────────────────────────────────

export type JerryMarker = {
    id: string        // crypto.randomUUID()
    position: number  // PPQN (same unit as OpenDAW's MarkerBox)
    label: string
}

export type JerryLaneType = "group" | "groupSustain" | "section"

export type JerryLaneData = {
    groupMarkers: JerryMarker[]
    groupSustainMarkers: JerryMarker[]
    sectionMarkers: JerryMarker[]
}

// Hue values used when rendering — matches OpenDAW's hsl(hue, 60%, 40%) convention
export const JERRY_LANE_HUES: Record<JerryLaneType, number> = {
    group: 43,          // amber — matches Base44 group color
    groupSustain: 270,  // purple — matches Base44 section color
    section: 195,       // teal — section markers
}

export const JERRY_LANE_LABELS: Record<JerryLaneType, string> = {
    group: "Groups",
    groupSustain: "G. Sustain",
    section: "Sections",
}

export const JERRY_DEFAULT_NAMES: Record<JerryLaneType, string[]> = {
    group: ["Verse", "Chorus", "Bridge", "Outro", "Intro"],
    groupSustain: ["Loop A", "Loop B", "Loop C", "Loop D", "Main"],
    section: ["Intro", "Verse", "Pre-Chorus", "Chorus", "Bridge", "Outro"],
}
